export default "__VITE_ASSET__BFknnm2I__"